var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"topbar",staticStyle:{"z-index":"10"}},[_c('TopBar')],1),_c('div',{staticClass:"router"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }